import { isOverviewEnabled } from '@/components/TopBar/overviewAccess'
import { investorBeforeEnter } from '@/router/rules/investorBeforeEnter'
import { realEstatesRoute } from '@/router/routes/contants'

// Garde de l'écran « Vue d'ensemble » (rollout progressif). FAIL-CLOSED : un compte hors
// liste blanche (overviewAccess) est redirigé vers « Mes biens », même s'il tape l'URL en
// direct. Pour la liste blanche, on applique ensuite le garde investisseur habituel
// (onboarding si aucun bien).
//
// IMPORTANT (Vue Router 4) : NE PAS déclarer le paramètre `next`. Dès qu'un garde a une
// arité >= 3, Vue Router attend un appel explicite à next() et n'utilise PAS la valeur de
// retour -> la navigation reste bloquée à l'infini. En arité 2, la valeur retournée
// (true | chemin de redirection) est appliquée automatiquement, comme edlBeforeEnter.
export const overviewBeforeEnter = async (to, from) => {
  if (!isOverviewEnabled()) {
    return realEstatesRoute.path
  }

  return investorBeforeEnter(to, from)
}
